import React, { FC } from "react";
import { WidgetProps } from "@rjsf/core";
import KioTextWidget from "@/framework/KioForm/widgets/KioTextWidget";

export const KioTextareaWidget: FC<WidgetProps> = (props) => {
  return <KioTextWidget {...props} multiline={true} />;
};

export default KioTextareaWidget;
